import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Event, Router, RouterOutlet} from "@angular/router";
import {CardComponent} from "../../../shared-module/components/card/card.component";
import {config} from "../../../../config";
import {MobileService} from "../../../shared-module/services/mobile.service";
import {NgOptimizedImage} from "@angular/common";
import {AuthService} from "../../../shared-module/services/auth.service";
import {SettingService} from "../../../shared-module/services/setting.service";
import {Title} from "@angular/platform-browser";
import {ApplicationSettings} from "../../../shared-module/interfaces/settings.interface";

@Component({
    selector: 'app-auth-layout',
  imports: [
    RouterOutlet,
    CardComponent,
    NgOptimizedImage
  ],
    templateUrl: './auth-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent implements OnInit {
  readonly mobileService: MobileService = inject(MobileService);
  readonly authService: AuthService = inject(AuthService);
  readonly router: Router = inject(Router);
  readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly settingService: SettingService = inject(SettingService);
  private titleService = inject(Title);
  public appName: string = '';
  public slogan: string = '';
  public showHeading: boolean | null = null;

  constructor() {
    this.router.events.subscribe((event: Event) => {
      if (
        event
        && Object.prototype.hasOwnProperty.call(event, 'snapshot')
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        && Object.prototype.hasOwnProperty.call(event.snapshot, 'data')
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        && Object.prototype.hasOwnProperty.call(event.snapshot.data, 'showHeader')
      ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.showHeading = event.snapshot.data.showHeader;
      }
    });
  }

  public ngOnInit(): void {
    this.settingService.settings.subscribe((settings: ApplicationSettings | null) => {
      if (settings) {
        this.appName = config.appName;
        this.slogan = config.companySlogan;
        this.titleService.setTitle(config.appName);
      }
    });
  }
}
